import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ce7cdfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-m-2" }
const _hoisted_2 = { style: {"height":"0.2em"} }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { id: "formContent" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { style: {"font-size":"20px"} }, "Cashier Login ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"left"} }, "The cashier session must be balanced before starting a new one.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"left"} }, "The system will track and include the amounts in the day-end balance report.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = { style: {"text-align":"left"} }
const _hoisted_11 = { style: {"text-align":"left"} }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "p-error" }
const _hoisted_16 = {
  key: 1,
  class: "p-error"
}
const _hoisted_17 = { class: "p-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showProgress)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            style: {"height":"0.2em"}
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.authenticate(!_ctx.v$.$invalid)), ["prevent"])),
          class: "p-fluid p-p-5"
        }, [
          _createElementVNode("span", null, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, "Cashier Name: " + _toDisplayString(_ctx.userName), 1),
            _createElementVNode("p", _hoisted_11, "Branch Name: " + _toDisplayString(_ctx.branchName), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_InputText, {
                id: "cashBalance",
                modelValue: _ctx.v$.cashBalance.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.cashBalance.$model) = $event)),
                class: _normalizeClass({
                'p-invalid': _ctx.v$.cashBalance.$invalid && _ctx.submitted,
              }),
                "aria-describedby": "email-error"
              }, null, 8, ["modelValue", "class"]),
              _createElementVNode("label", {
                for: "cashBalance",
                class: _normalizeClass({
                'p-error': _ctx.v$.cashBalance.$invalid && _ctx.submitted,
              })
              }, "Cash Balance*", 2)
            ]),
            (_ctx.v$.cashBalance.$error && _ctx.submitted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.cashBalance.$errors, (error, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      id: "email-error",
                      key: index
                    }, [
                      _createElementVNode("small", _hoisted_15, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]))
              : (
              (_ctx.v$.cashBalance.$invalid && _ctx.submitted) || _ctx.v$.cashBalance.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.cashBalance.required.$message.replace("Value", "Cash Balance")), 1))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Button, {
              type: "submit",
              label: "Sign In",
              icon: "pi pi-unlock",
              class: "p-button-primary p-button-raised p-button-rounded"
            })
          ])
        ], 32)
      ])
    ])
  ]))
}